import { render, staticRenderFns } from "./assessmentAdd.vue?vue&type=template&id=6f06f9d6&scoped=true"
import script from "./assessmentAdd.vue?vue&type=script&lang=js"
export * from "./assessmentAdd.vue?vue&type=script&lang=js"
import style0 from "./assessmentAdd.vue?vue&type=style&index=0&id=6f06f9d6&prod&scoped=true&lang=less"
import style1 from "./assessmentAdd.vue?vue&type=style&index=1&id=6f06f9d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06f9d6",
  null
  
)

export default component.exports